// © Microsoft Corporation. All rights reserved.

/// <summary>Adds functions events.bind and events.unbind that bind and unbind events</summary>

export default {
    bind: bindEvent,
    unbind: unbindEvent
};

function bindEvent(element, type, handler)
{
    if (element.addEventListener)
    {
        element.addEventListener(type, handler, false);
    }
}

function unbindEvent(element, type, handler)
{
    if (element.removeEventListener)
    {
        element.removeEventListener(type, handler, false);
    }
}
